import {
	MutableRefObject,
	RefObject,
	useRef,
} from 'react';

const useFocus = (): [any, () => void] => {
	const htmlElRef: RefObject<HTMLElement> = useRef<HTMLElement>(null);
	const setFocus = (): void => {
		setTimeout(() => {
			console.log("Setting focus", htmlElRef?.current);
			htmlElRef?.current?.focus?.();
		}, 100);
	};

	return [htmlElRef, setFocus];
};

export default useFocus;